<template>
    <div>
        <b-modal
            title="Create Invite"
            ref="createInviteModal"
            id="createInviteModal"
            :ok-only="created"
            :ok-title="okButtonText"
            @show="reset()"
            @ok="onOK($event)"
        >

            <InviteList v-if="showList" :sessionId="$store.getters.sessionId" />
            <a href="" v-else @click.prevent="showInvites">show previous invites</a>

            <div v-if="!created">
                <!-- <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="invitee@example.com - not required at the moment"
                  v-model="email"
                />
                </div>-->
                <div class="input-group mb-3">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="guest's name (e.g Tim Davie)"
                        v-model="name"
                    />
                </div>
                <div v-if="errors.length > 0" class="input-group mb-3">
                    <div
                        v-for="(err, i) in errors"
                        v-bind:key="i"
                        class="alert alert-danger"
                    >
                        {{ err }}
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="input-group mb-3">
                    <input
                        ref="inviteLinkText"
                        type="text"
                        class="form-control"
                        v-model="inviteLink"
                        readonly
                        @click="copyLink"
                    />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import api from "@/api";
import InviteList from './InviteList';

export default {
    name: "CreateInvite",

    components: {
        InviteList
    },

    data: function () {
        return {
            title: "Create Invite",
            created: false,
            email: null,
            name: null,
            inviteLink: "",
            errors: [],
            showList: false,
        };
    },

    computed: {
        okButtonText() {
            if (this.created === true) {
                return "OK";
            }
            return "Create Invite";
        },
    },

    methods: {
        showInvites() {
            this.showList = true;
        },

        onOK(event) {
            if (!this.created === true) {
                this.createInvite();
                event.preventDefault();
            }
        },

        async createInvite() {
            if (!this.name) {
                this.errors.push("You must enter a display name");
                return;
            }

            try {
                let result = await api.invites.create({
                    name: this.name,
                    sessionId: this.$store.getters.sessionId,
                    sessionName: this.$store.getters.sessionName
                });

                let { error, message, results } = result;
                if (error) {
                    throw new Error(message);
                }

                let {invite} = results;
                this.inviteLink = process.env.VUE_APP_INVITE_BASE_URL + invite.inviteId;
                this.created = true;

                return true;
            } catch (err) {
                this.errors.push(err.message);
            }
        },

        copyLink: function () {
            this.$refs.inviteLinkText.select();
            document.execCommand("copy");
        },

        reset: function () {
            this.showList = false;
            this.created = false;
            this.email = null;
            this.name = null;
            this.errors = [];
        },
    },
};
</script>